<template>
  <div>
    <!-- 头部内容 -->
    <div class="header">
      <div class="content flex between">
        <div class="logo pointer flex items-center">
          <img src="../assets/images/logo.png" alt="" style="width: 100%" />
        </div>
        <!-- 搜索框区域 -->
        <div class="pt-20">
          <!-- 上部分 -->
          <div class="flex items-center">
            <el-input
              v-model="keyWords"
              prefix-icon="el-icon-search"
              style="width: 442px"
              placeholder="请输入关键词搜索"
            ></el-input>
            <el-button @click="clickSearch">搜索</el-button>
          </div>
          <!-- 下部分 -->
          <div class="flex mt-5 flex items-center" style="width: 442px">
            <div class="ml-20">
              <span
                @click="liShiSearch"
                :class="keysActive == 1 ? 'color-blue' : ''"
                class="size12 pointer"
                >历史搜索</span
              >
              <span class="size12 ml-5 mr-5">|</span>
              <span
                @click="keySearch"
                class="size12 pointer"
                :class="keysActive == 2 ? 'color-blue' : ''"
                >热门关键词</span
              >
            </div>
            <div class="ml-20">
              <span
                @click="clickSearchItem(item.searchItem)"
                style="padding: 0 5px"
                class="size12 pointer color-gray"
                v-for="(item, i) in keyWordsList"
                :key="i"
                >{{ item.searchItem }}
              </span>
            </div>
          </div>
        </div>
        <!-- 登录注册按钮 -->
        <div class="user-box flex flex-center mt-15" v-if="!loginName">
          <span class="color-blue pointer" @click="goLogin">登录</span>
          <span class="ml-10 color-blue mr-10">|</span>
          <span class="color-blue pointer" @click="goRegister">注册</span>
        </div>
        <div class="user-box flex flex-center mt-15" v-else>
          <span class="color-blue pointer">{{ loginName }}</span>
          <!-- <span class="color-blue pointer">123213211231231231</span> -->
          <span class="ml-10 color-blue mr-10">|</span>
          <span class="color-blue pointer" @click="goOut">退出</span>
        </div>
      </div>
    </div>

    <!-- 导航内容 -->
    <div class="nav">
      <div class="content flex between items-center">
        <div
          class="size16 pointer father"
          @click="navClick(item.id, item.url)"
          v-for="item in navList"
          :key="item.id"
          :class="activeId == item.id ? 'active' : ''"
        >
          {{ item.name }}
          <div class="border" v-if="isShow && item.id == 7"></div>
          <div class="child" v-if="isShow && item.id == 7">
            <div
              class="child-item"
              @click.stop="navClick(child.id, child.url)"
              v-for="child in item.children"
              :key="child.id"
            >
              {{ child.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 具体内容 -->
    <div>
      <router-view></router-view>
    </div>

    <Result
      :title="resultTitle"
      :SubTitle="subTitle1"
      :isShow="resultShow"
      @change="resultClose"
    />
  </div>
</template>

<script>
import Result from "../components/Result.vue";

export default {
  components: { Result },
  data() {
    return {
      resultTitle: "",
      subTitle1: "",
      resultShow: false,
      keysActive: 2,
      isLogin: false, //用户是否登陆
      navList: [
        { id: 1, name: "首页", url: "/index", children: [] },
        { id: 2, name: "竞价平台", url: "/jjdt", children: [] },
        { id: 3, name: "竞价列表", url: "/jjlb", children: [] },
        { id: 4, name: "竞价公告", url: "/jingjiagonggao", children: [] },
        { id: 5, name: "成交公告", url: "/chengjiaogonggao", children: [] },
        { id: 6, name: "系统公告", url: "/xtgg", children: [] },
        {
          id: 7,
          name: "供应商信息",
          url: "/index",
          children: [
            { id: 701, name: "信息修改", url: "/xxxg", children: [] },
            { id: 702, name: "我参与的", url: "/canyu", children: [] },
            { id: 703, name: "我中标的", url: "/zhongbiao", children: [] },
          ],
        },
        { id: 8, name: "关于我们", url: "/gywm", children: [] },
      ],
      activeId: 1,
      isShow: false,
      loginName: null,
      keyWordsList: [],
      keyWords: null,
    };
  },
  created() {
    this.loginName = window.sessionStorage.getItem("loginName");
  },
  mounted() {
    this.getKeyWords();
    // this.formatMonenyNumber(50000);
  },
  methods: {
    resultClose() {
      this.resultShow = false;
    },
    clickSearchItem(item) {
      this.keyWords = item;
      this.clickSearch();
    },
    //点击搜索按钮
    clickSearch() {
      if (!this.keyWords) return;
      let obj = {};
      obj.searchItem = this.keyWords;
      let arr = JSON.parse(window.localStorage.getItem("keyWordsList"));
      if (!arr) {
        arr = [];
      }
      arr.unshift(obj);

      window.localStorage.setItem("keyWordsList", JSON.stringify(arr));
      // window.sessionStorage.setItem("keyWords", this.keyWords);
      this.resetSetItem("keyWords", this.keyWords);

      if (this.$route.path != "/jjlb") {
        // window.sessionStorage.setItem("isSearch", false);
        this.$router.push({
          path: "/jjlb",
        });
      }

      this.keyWords = "";
    },
    //点击历史搜索
    liShiSearch() {
      this.keyWordsList = [];
      this.keysActive = 1;
      let arr = JSON.parse(window.localStorage.getItem("keyWordsList"));
      if (arr && arr.length && arr.length > 0) {
        this.keyWordsList = arr.slice(0, 4);
      }
    },
    //热搜关键词
    keySearch() {
      this.keysActive = 2;
      this.getKeyWords();
    },
    //点击退出
    goOut() {
      this.loginName = null;
      window.sessionStorage.clear();
      this.$router.push("/");
    },
    //获取热门关键词
    async getKeyWords() {
      const { data: res } = await this.$axios.get(
        "/api/platInfo/getSearchInfo",
        {
          params: {
            type: 1,
          },
        }
      );
      if (res.code == 200) {
        res.data = res.data.slice(0, 4);
        this.keyWordsList = res.data;
      } else {
        console.log(res.msg);
        return;
      }
    },
    goLogin() {
      this.$router.push("/login");
    },
    goRegister() {
      this.$router.push("/register");
    },
    navClick(id, url) {
      this.activeId = id;
      if (id == 7) {
        this.isShow = true;
      } else {
        this.isShow = false;
        if (id == 701 || id == 702 || id == 703) {
          if (window.sessionStorage.getItem("userId")) {
            this.$router.push(url);
          } else {
            this.resultTitle = "请登录";
            this.subTitle1 = "";
            this.resultShow = true;

            setTimeout(() => {
              this.$router.push("/login");
            }, 1000);
          }
        } else {
          this.$router.push(url);
        }
      }

      //
    },
  },
};
</script>

<style scoped lang="less">
.color-blue {
  color: #1c65c4;
  font-weight: bold;
}
.color-gray {
  color: #ccd9e9;
}
.color-black {
  color: #02224b;
}
.header {
  .content {
    width: 1200px;
    margin: 0 auto;
    .logo {
      width: 330px;
      // background-color: #1c65c4;
      color: #fff;
      text-align: center;
      line-height: 84px;
      height: 84px;
    }

    .user-box {
      // width: 122px;
      padding-left: 20px;
      padding-right: 20px;
      height: 40px;
      line-height: 40px;
      border: 1px solid #1c65c4;
      border-radius: 20px;
    }
    /deep/.el-input__inner {
      border: 1px solid transparent;
      background-color: rgba(231, 237, 245, 0.32);
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 0px;
      border-top-right-radius: 0px;
    }
    /deep/.el-button {
      font-size: 16px;
      background-color: #1c65c4;
      color: #fff;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      border-bottom-left-radius: 0px;
      border-top-left-radius: 0px;
    }
  }
}

.nav {
  box-shadow: 0px 3px 6px rgba(204, 217, 233, 0.7);
  padding: 15px 0;
  position: relative;
  z-index: 1000;
  .content {
    width: 1200px;
    margin: 0 auto;
    .active {
      color: #1c65c4;
      font-weight: bold;
    }
    .father {
      position: relative;
      .border {
        width: 16px;
        height: 2px;
        background: #1c65c4;
        margin: 0 auto;
        position: absolute;
        bottom: -15px;
        left: 50%;
        margin-left: -8px;
      }
      .child {
        position: absolute;
        top: 40px;
        left: 0;
        z-index: 999999;
        background-color: #fff;
        padding: 20px;

        min-width: 110px;
        text-align: center;
        box-shadow: 0px 3px 6px rgba(204, 217, 233, 0.7);
        box-sizing: border-box;
        .child-item {
          font-size: 14px;
          color: #1c65c4;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>